module.exports = __webpack_public_path__ + "img/img.68ac2c7c.png";